var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "wizardOverlay",
      staticClass: "widget-ai-wizard-overlay",
      attrs: { tabindex: "0" },
      on: { keydown: _vm.handleKeyDown, keyup: _vm.handleKeyUp },
    },
    [
      _c("div", { staticClass: "widget-ai-wizard" }, [
        _c(
          "div",
          { staticClass: "wizard-header" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("a-icon", {
              staticClass: "close-button",
              attrs: { type: "close" },
              on: { click: _vm.handleClose },
            }),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.commands.length
          ? _c("div", { staticClass: "prompt-stage" }, [
              _c(
                "div",
                { staticClass: "prompt-container" },
                [
                  _c("h4", [
                    _vm._v(
                      "Supsis Asistan'a nasıl bir dashboard istediğinizi anlatın"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("s2-textarea", {
                    ref: "promptTextarea",
                    staticClass: "search-input w-100",
                    attrs: {
                      rows: 4,
                      placeholder:
                        "Örnek: Satış performansını gösteren grafikler ve sayısal veriler istiyorum...",
                    },
                    model: {
                      value: _vm.customerPrompt,
                      callback: function ($$v) {
                        _vm.customerPrompt = $$v
                      },
                      expression: "customerPrompt",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "submit-button",
                      attrs: { type: "primary", loading: _vm.copilotWaiting },
                      on: { click: _vm.handleAIRecommendation },
                    },
                    [
                      _vm._v(
                        "\n                    Supsis Asistan'a İlet\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "example-prompts" }, [
                _c("h4", [_vm._v("Örnek İstekler:")]),
                _vm._v(" "),
                _c("div", { staticClass: "prompt-slider-container" }, [
                  _c(
                    "div",
                    { ref: "slider", staticClass: "prompt-slider" },
                    _vm._l(_vm.examplePrompts, function (prompt, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "prompt-slide" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "prompt-card",
                              on: {
                                click: function ($event) {
                                  return _vm.selectExamplePrompt(prompt)
                                },
                              },
                            },
                            [
                              _c("a-icon", { attrs: { type: "bulb" } }),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(prompt))]),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "slider-controls" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "control-btn prev",
                          on: { click: _vm.slidePrev },
                        },
                        [_c("a-icon", { attrs: { type: "left" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "control-btn next",
                          on: { click: _vm.slideNext },
                        },
                        [_c("a-icon", { attrs: { type: "right" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _c(
              "div",
              [
                _c("a-progress", {
                  staticStyle: { "margin-bottom": "16px" },
                  attrs: {
                    percent: _vm.progressPercent,
                    "stroke-color": "#1890ff",
                    "show-info": "",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wizard-steps" },
                  _vm._l(_vm.steps, function (step, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "wizard-step",
                        class: step.status,
                      },
                      [
                        step.status === "waiting"
                          ? _c("a-icon", {
                              staticStyle: {
                                color: "#ccc",
                                "margin-right": "8px",
                              },
                              attrs: { type: "pause-circle", theme: "filled" },
                            })
                          : step.status === "in-progress"
                          ? _c("a-icon", {
                              staticStyle: {
                                color: "#1890ff",
                                "margin-right": "8px",
                              },
                              attrs: { type: "loading" },
                            })
                          : step.status === "success"
                          ? _c("a-icon", {
                              staticStyle: {
                                color: "#52c41a",
                                "margin-right": "8px",
                              },
                              attrs: { type: "check-circle", theme: "filled" },
                            })
                          : step.status === "error"
                          ? _c("a-icon", {
                              staticStyle: {
                                color: "#f5222d",
                                "margin-right": "8px",
                              },
                              attrs: { type: "close-circle", theme: "filled" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(step.displayLabel))]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "d-flex align-items-center gap-5" }, [
      _c("img", {
        attrs: { src: "/static/img/copilot.png", width: "30", height: "30" },
      }),
      _vm._v("\n                Supsis Asistan: Dashboard\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }